import { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

interface ResourceType {
    id: string;
    name: string;
}

interface Technology {
    id: string;
    name: string;
    typeId: string;
}

export function useResourceDetails() {
    const [types, setTypes] = useState<Record<string, ResourceType>>({});
    const [technologies, setTechnologies] = useState<Record<string, Technology>>({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchDetails = async () => {
            try {
                // Buscar tipos de recursos
                const typesSnapshot = await getDocs(collection(db, 'resourceTypes'));
                const typesMap: Record<string, ResourceType> = {};
                typesSnapshot.docs.forEach(doc => {
                    typesMap[doc.id] = {
                        id: doc.id,
                        name: doc.data().name
                    };
                });
                setTypes(typesMap);

                // Buscar tecnologias
                const techsSnapshot = await getDocs(collection(db, 'technologies'));
                const techsMap: Record<string, Technology> = {};
                techsSnapshot.docs.forEach(doc => {
                    techsMap[doc.id] = {
                        id: doc.id,
                        name: doc.data().name,
                        typeId: doc.data().typeId
                    };
                });
                setTechnologies(techsMap);

                setLoading(false);
            } catch (err) {
                setError('Erro ao carregar detalhes dos recursos');
                setLoading(false);
            }
        };

        fetchDetails();
    }, []);

    const getTypeName = (typeId: string) => types[typeId]?.name || typeId;
    const getTechnologyName = (techId: string) => technologies[techId]?.name || techId;

    return {
        getTypeName,
        getTechnologyName,
        loading,
        error
    };
} 